import React from 'react';
import './HowItWorks.css';

const HowItWorks = () => {
  const steps = [
    {
      number: '1',
      icon: '🏛️',
      title: 'Irish Immigration Publishes',
      description: 'The visa office publishes its decision list',
      detail: 'Official NDVO updates'
    },
    {
      number: '2',
      icon: '⚡',
      title: 'We Check for Updates',
      description: 'Our system monitors for changes automatically',
      detail: 'Automated monitoring'
    },
    {
      number: '3',
      icon: '📧',
      title: 'You Get Notified',
      description: 'Email alerts and optional browser notifications',
      detail: 'Browser enrollment required for push'
    },
    {
      number: '4',
      icon: '🎉',
      title: 'Plan Your Next Steps',
      description: 'Read the official decision and relevant guidance',
      detail: 'For approvals and refusals'
    }
  ];

  return (
    <div className="how-it-works-section">
      <div className="how-it-works-header">
        <h2>How We Track Your Visa Decision</h2>
        <p className="section-subtitle">
          Automated checks of official NDVO publications for your tracked reference
        </p>
      </div>

      <div className="steps-container">
        {steps.map((step, index) => (
          <React.Fragment key={step.number}>
            <div className="step-card">
              <div className="step-number">{step.number}</div>
              <div className="step-icon">{step.icon}</div>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-description">{step.description}</p>
              <p className="step-detail">{step.detail}</p>
            </div>
            {index < steps.length - 1 && (
              <div className="step-connector">
                <div className="connector-line"></div>
                <div className="connector-arrow">→</div>
              </div>
            )}
          </React.Fragment>
        ))}
      </div>

      <div className="timing-highlight">
        <div className="timing-icon">⏱️</div>
        <div className="timing-content">
          <div className="timing-stat">Automated monitoring with <strong>decision alerts</strong></div>
          <div className="timing-comparison">Timing depends on official publication, processing and provider delivery.</div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
